import { gql } from 'apollo-angular'

export const GET_PRORATION_FACTOR = gql`
  query ProrationFactor($organizationId: Int) {
    prorationFactor(organizationId: $organizationId) {
      factor
    }
  }
`
